import {
    withInterstitial,
} from 'wanderu-component-page-loader';

const AppPage = withInterstitial(import('./pages/ProductReview'), {
    onLoad(module, ...args) {
        module.onLoad(module, ...args);
    },
});

export default [
    {
        path: '/travel-review/:tripId/',
        component: AppPage,
        key: '/travel-review/:tripId/',
    },
];
